module.exports = __webpack_public_path__ + "static/time-line.f8b713ab.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/time-line.png
// module id = 1056
// module chunks = 2